import Vue from 'vue';

// Store
import store from '@/app/stores/store.js';

// Constants
import { TOKEN, ERROR_MSG } from '@/app/constants/status-constants';

export const apiInterceptor = (instance) => {
	// Interceptors
	instance.interceptors.request.use(config => {
		const userToken = store.getters.getUserToken;
		const idempotencyKey = store.getters.getIdempotencyKey;
		const checkoutFlag = store.getters.getCheckoutFlag;

		if (userToken) {
			config.headers['Authorization'] = `Bearer ${userToken}`;
		}
		
		if (idempotencyKey && checkoutFlag) {
			// This ensures idempotencyKey does not show up on any other requests.
			store.commit('setIsCheckoutFlag', false);
			config.headers['Idempotency-Key'] = idempotencyKey;
		}

		return config;
	}, function (error) {
		return Promise.reject(error);
	});

	instance.interceptors.response.use(response =>  {
		// Redirect to login if token has expired
		if (response.data.errors) {
			const hasTokenError = response.data.errors.some(e => {
				return e.message === TOKEN.EXPIRED || e.message === TOKEN.INVALID;
			});
	
			if (hasTokenError) {
				store.dispatch('logout');
			} 

			const hasUserInactiveError = response.data.errors.some(e => {
				return e.message === ERROR_MSG.INACTIVE_USER;
			});
			const userDetails = store.getters.getUserDetails;
			
			if (hasUserInactiveError && userDetails.id) {
				store.dispatch('logout');
				store.commit('setAuthMessage', {status: 'failed', message: ERROR_MSG.INACTIVE_USER});
			}
		}

		return response;
	}, function (error) {
		// Show timeout error
		if (error.message === ERROR_MSG.TIMEOUT_EXCEEDED) {
			Vue.notify({
				group: 'notifs',
				type: 'error',
				title: ERROR_MSG.INTERNAL_ERROR_TITLE,
				text: ERROR_MSG.INTERNAL_CONNECTION_TIMEOUT,
				duration: -1,
				closeOnClick: true
			});
		}
		return Promise.reject(error);
	});
}